"use client";

import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import Link from "next/link";
import Image from "next/image";
import Service from "./pageh";

const services = [
  {
    title: "Micro Loans",
    image: "/projects/profile.jpg",
    description:
      "Tailored small-scale financing solutions designed to empower entrepreneurs and small businesses.",
    lists: [
      "Working capital loans",
      "Equipment financing",
      "Trade credit facilities",
    ],
    details:
      "Our micro loans feature flexible repayment terms, competitive interest rates, and quick approval processes to support your business growth and operational needs.",
  },
  {
    title: "Agricultural Financing",
    image: "/projects/profile2.jpg",
    description:
      "Specialized financial products for farmers and agribusinesses to boost productivity.",
    lists: [
      "Seasonal crop financing",
      "Livestock loans",
      "Irrigation equipment loans",
    ],
    details:
      "We offer customized agricultural loans with crop-cycle aligned repayment schedules, input financing, and technical support to enhance farm productivity and sustainability.",
  },
];
// Array of project objects: each contains a title, description, and an image.
const otheryegna = [
  {
    title: "Special Property Loan",
    description:
      "This loan is designed for employees of YMFI’s strategic partners, offering a lower interest rate than conventional fixed asset loans. Loan terms range from 12 to 60 months, with monthly or quarterly repayments.",
    image: "/projects/etege1.png",
  },
  {
    title: "Agriculture Loan",
    description:
      "This loan will be availed to middle income farmer borrowers for purchasing agricultural inputs: like fertilizer, improved seed, land rent, purchase of oxen and for fattening activities.",
    image: "/projects/etege.png",
  },
  {
    title: "Special Emergency Loan",
    description:
      "This short-term credit is designed for businesses needing urgent financing, such as importers and contractors. Loans must be repaid within six months, with flexible repayment options: monthly, quarterly, or lump sum at maturity. It supports businesses with immediate financial needs and quick returns.",

    image: "projects/profile3.jpg",
  },
  {
    title: "Urban Agriculture and Innovation Loan",
    description:
      "This loan supports agricultural activities in urban areas, including oxen, poultry, dairy, fattening, animal husbandry, irrigation, land rent, handicrafts, and beekeeping. The loan term ranges from 12 to 36 months, catering to small-scale farmers and agribusinesses.",

    image: "projects/profile3.jpg",
  },
];
const projects = [
  {
    title: "ETEGE",
    description:
      "Yegna MFI provides financial support to women entrepreneurs by offering low-interest, long-term loans for startups and business expansion. These loans are exclusively for women-led enterprises, with interest rates lower than conventional rates. Loan terms range from 12 to 36 months, with repayment on a monthly or quarterly basis.",
    image: "/projects/etege1.png",
  },
  {
    title: "Agriculture Loan",
    description:
      "This loan will be availed to middle income farmer borrowers for purchasing agricultural inputs: like fertilizer, improved seed, land rent, purchase of oxen and for fattening activities.",
    image: "/projects/etege.png",
  },
  {
    title: "Special Emergency Loan",
    description:
      "This short-term credit is designed for businesses needing urgent financing, such as importers and contractors. Loans must be repaid within six months, with flexible repayment options: monthly, quarterly, or lump sum at maturity. It supports businesses with immediate financial needs and quick returns.",

    image: "projects/profile3.jpg",
  },
  {
    title: "Urban Agriculture and Innovation Loan",
    description:
      "This loan supports agricultural activities in urban areas, including oxen, poultry, dairy, fattening, animal husbandry, irrigation, land rent, handicrafts, and beekeeping. The loan term ranges from 12 to 36 months, catering to small-scale farmers and agribusinesses.",

    image: "projects/profile3.jpg",
  },

  {
    title: "Public Association Loan",
    description:
      "Yegna MFI collaborates with governmental institutions and public associations (Eder, Shemachoch, Equib) to provide low-interest loans. Loan size is based on customer savings, capped at 1% of MFI’s capital, and requires 150% collateral coverage. Terms range from 1 to 24 months, with monthly or quarterly repayments.",

    image: "projects/profile3.jpg",
  },
];

const brandGradient = "linear-gradient(112.68deg, #F16823 0%, #EC1276 100%)";

// Generate an array of circle objects for the animated background.
const circles = Array.from({ length: 8 }, (_, i) => ({
  id: i,
  x: Math.random() * 100,
  y: Math.random() * 100,
  delay: Math.random() * 3,
}));

// The text for the typing effect in the animated background.
const text = "Details of our services & solutions";

// Variants for the projects section's background floating element.
const backgroundVariants = {
  rest: { x: 0, y: 0 },
  hover: { x: [0, 15, -15, 0], y: [0, -15, 15, 0] },
};

// Variants for the top-left rectangular block.
const rectTopLeftVariants = {
  rest: { x: 0, y: 0 },
  hover: { x: -10, y: -10 },
};

// Variants for the bottom-right rectangular block.
const rectBottomRightVariants = {
  rest: { x: 0, y: 0 },
  hover: { x: 10, y: 10 },
};

export default function ServiceCards() {
  // State to control the typing effect for the main heading.
  const [currentIndex, setCurrentIndex] = useState(0);

  // useEffect simulates a typing effect by incrementing currentIndex.
  useEffect(() => {
    if (currentIndex < text.length) {
      const timeout = setTimeout(() => {
        setCurrentIndex((prev) => prev + 1);
      }, 100); // 100ms delay between characters
      return () => clearTimeout(timeout);
    }
  }, [currentIndex]);
  const brandGradient =
    "linear-gradient(112.68deg,rgb(139, 158, 126) 0%,rgb(16, 192, 40) 100%)";

  return (
    <div className="mt-30 mb-20 space-y-12">
      {/* ---------- Animated Background Section (Do Not Alter) ---------- */}
      <div className="relative w-full overflow-hidden bg-gradient-to-b from-[#136207] to-[#0f4a05] py-24 md:py-32">
        {/* Subtle pattern overlay */}
        <div className="absolute inset-0 opacity-10">
          <svg
            className="h-full w-full"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 100 100"
            preserveAspectRatio="none"
          >
            <path
              d="M0,0 L100,0 L100,100 L0,100 Z"
              fill="none"
              stroke="white"
              strokeWidth="0.5"
              strokeDasharray="2 2"
            />
          </svg>
        </div>

        {/* Content container */}
        <div className="container relative mx-auto px-6">
          <h1 className="text-center font-orbitron text-4xl font-bold text-white sm:text-5xl md:text-6xl lg:text-7xl">
            <span className="relative inline-block">
              {text.substring(0, currentIndex)}
              {/* Enhanced cursor animation */}
              <motion.span
                className="absolute -right-3 top-0 h-12 w-1 bg-white"
                initial={{ opacity: 0 }}
                animate={{
                  opacity: [0, 1, 0],
                  scaleY: [1, 1.2, 1],
                }}
                transition={{
                  repeat: Infinity,
                  duration: 0.8,
                  ease: "easeInOut",
                }}
              />
            </span>
          </h1>

          {/* Decorative elements */}
          <div className="mt-12 flex justify-center space-x-4">
            {[1, 2, 3].map((item) => (
              <motion.div
                key={item}
                className="h-2 rounded-full bg-white/30"
                initial={{ width: 0 }}
                animate={{ width: item % 2 === 0 ? "40px" : "20px" }}
                transition={{
                  duration: 0.6,
                  delay: item * 0.2,
                  repeat: Infinity,
                  repeatType: "reverse",
                }}
              />
            ))}
          </div>
        </div>

        {/* Wave divider at bottom */}
        <div className="absolute bottom-0 left-0 right-0 h-12 overflow-hidden">
          <svg
            viewBox="0 0 1200 120"
            preserveAspectRatio="none"
            className="h-full w-full"
          >
            <path
              d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z"
              opacity=".25"
              className="fill-white"
            ></path>
            <path
              d="M0,0V15.81C13,36.92,27.64,56.86,47.69,72.05,99.41,111.27,165,111,224.58,91.58c31.15-10.15,60.09-26.07,89.67-39.8,40.92-19,84.73-46,130.83-49.67,36.26-2.85,70.9,9.42,98.6,31.56,31.77,25.39,62.32,62,103.63,73,40.44,10.79,81.35-6.69,119.13-24.28s75.16-39,116.92-43.05c59.73-5.85,113.28,22.88,168.9,38.84,30.2,8.66,59,6.17,87.09-7.5,22.43-10.89,48-26.93,60.65-49.24V0Z"
              opacity=".5"
              className="fill-white"
            ></path>
            <path
              d="M0,0V5.63C149.93,59,314.09,71.32,475.83,42.57c43-7.64,84.23-20.12,127.61-26.46,59-8.63,112.48,12.24,165.56,35.4C827.93,77.22,886,95.24,951.2,90c86.53-7,172.46-45.71,248.8-84.81V0Z"
              className="fill-white"
            ></path>
          </svg>
        </div>
      </div>

      <div className="mt-6">
        {/* Header with faster animation */}
        <motion.h2
          initial={{ opacity: 1, y: 0 }} // Start visible
          className="mb-12 text-center text-4xl font-bold text-[#136207] sm:text-5xl"
        >
          <span className="relative inline-block">
            <span className="bg-gradient-to-r from-[#136207] to-[#88cf07] bg-clip-text text-transparent">
              Our Services
            </span>
            <span className="absolute bottom-0 left-0 h-1 w-full bg-gradient-to-r from-[#136207] to-[#88cf07]"></span>
          </span>
        </motion.h2>

        {/* Description with no animation delay */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4, duration: 0.6 }}
          className="mx-auto mb-5 mt-5 max-w-[1500px] text-center font-poppins text-xl text-gray-800"
        >
          <span className="font-semibold text-[#136207]">
            Yegna Microfinance
          </span>{" "}
          provides comprehensive
          <span className="font-medium text-[#136207]">
            {" "}
            financial solutions
          </span>{" "}
          and
          <span className="font-medium text-[#136207]"> banking services</span>,
          delivering
          <span className="relative inline-block">
            <span className="z-10"> inclusive</span>
            <span className="absolute bottom-0 left-0 h-2 w-full -rotate-1 bg-[#88cf07]/30"></span>
          </span>{" "}
          and accessible financial products tailored to diverse needs. Our core
          offerings include:
          <span className="mx-1 font-medium text-[#136207]">
            interest-free loans (LANA IF)
          </span>
          ,
          <span className="mx-1 font-medium text-[#136207]">SME financing</span>
          ,
          <span className="mx-1 font-medium text-[#136207]">
            savings accounts
          </span>
          , and
          <span className="mx-1 font-medium text-[#136207]">
            financial training
          </span>{" "}
          - all designed to
          <span className="relative inline-block">
            <span className="z-10">empower communities</span>
            <span className="absolute bottom-0 left-0 h-2 w-full -rotate-1 bg-[#88cf07]/30"></span>
          </span>
          , enhance financial literacy, and promote economic growth.
        </motion.div>

        {/* Services Grid with optimized animations */}
        <div className="mt-20 grid grid-cols-1 gap-12 px-4 sm:grid-cols-2 lg:grid-cols-2 xl:gap-16">
          {services.map((service, index) => (
            <div key={index} className="group relative">
              {/* Image Container */}
              <div className="relative h-80 w-full overflow-hidden rounded-xl shadow-lg">
                <Image
                  src={service.image}
                  alt={service.title}
                  fill
                  className="object-cover transition-transform duration-300 group-hover:scale-105"
                  priority // Preload important images
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#136207]/30 to-transparent" />
              </div>

              {/* Content Section */}
              <div className="mt-8">
                <div className="flex items-start">
                  <div className="mr-4 h-8 w-1 bg-gradient-to-b from-[#136207] to-[#88cf07]"></div>
                  <div>
                    <h3 className="text-2xl font-bold text-[#136207]">
                      {service.title}
                    </h3>
                    <div className="mt-3 h-1 w-16 bg-gradient-to-r from-[#136207] to-[#88cf07]"></div>
                  </div>
                </div>

                <p className="mt-6 text-gray-700">{service.description}</p>

                <ul className="mt-6 space-y-3 text-gray-600">
                  {service.lists.map((item, idx) => (
                    <li
                      key={idx}
                      className="flex items-start transition-transform hover:translate-x-2"
                    >
                      <svg
                        className="mr-3 mt-1 h-5 w-5 flex-shrink-0 text-[#88cf07]"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Decorative elements */}
              <div className="absolute -bottom-4 -left-4 h-16 w-16 rounded-full bg-[#88cf07]/20"></div>
              <div className="absolute -right-4 -top-4 h-12 w-12 rounded-lg bg-[#136207]/20"></div>
            </div>
          ))}
        </div>
      </div>
      {/* ---------- Projects Section (Fixed) ---------- */}
      <div className="mt-20 px-4 lg:mx-auto lg:max-w-[1500px]" id="projects">
        {/* <h2 className="mb-10 text-center font-orbitron text-4xl font-bold text-[#136207] underline decoration-[#136207] decoration-4 sm:text-5xl">
  Yegna Unique Loan
  </h2> */}

        <div className="py-16">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="mb-16 text-center text-4xl font-bold text-[#136207] sm:text-5xl"
          >
            <span className="relative inline-block">
              <span className="bg-gradient-to-r from-[#136207] to-[#88cf07] bg-clip-text text-transparent">
                Yegna Unique Loan
              </span>
              <motion.span
                className="absolute bottom-0 left-0 h-1 w-full bg-gradient-to-r from-[#136207] to-[#88cf07]"
                initial={{ scaleX: 0 }}
                animate={{ scaleX: 1 }}
                transition={{ duration: 0.8, delay: 0.3 }}
              />
            </span>
          </motion.h2>

          <div className="mt-16 space-y-28">
            {projects.map((project, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="group relative"
              >
                <div
                  className={`flex flex-col ${index % 2 ? "md:flex-row-reverse" : "md:flex-row"} items-center gap-10 md:gap-16`}
                >
                  {/* Text Section */}
                  <motion.div
                    className="z-10 space-y-6 md:w-1/2"
                    initial={{ x: index % 2 ? 50 : -50 }}
                    whileInView={{ x: 0 }}
                    transition={{ duration: 0.6 }}
                  >
                    <div className="flex items-start">
                      <motion.div
                        className="mr-4 h-8 w-1 bg-gradient-to-b from-[#136207] to-[#88cf07]"
                        initial={{ scaleY: 0 }}
                        whileInView={{ scaleY: 1 }}
                        transition={{ duration: 0.5 }}
                      />
                      <div>
                        <motion.h3
                          className="text-3xl font-bold text-[#136207]"
                          initial={{ opacity: 0 }}
                          whileInView={{ opacity: 1 }}
                          transition={{ delay: 0.2 }}
                        >
                          {project.title}
                        </motion.h3>
                        <motion.div
                          className="mt-3 h-1 w-16 bg-gradient-to-r from-[#136207] to-[#88cf07]"
                          initial={{ scaleX: 0 }}
                          whileInView={{ scaleX: 1 }}
                          transition={{ delay: 0.4 }}
                        />
                      </div>
                    </div>

                    <motion.p
                      className="text-lg text-gray-700"
                      initial={{ opacity: 0 }}
                      whileInView={{ opacity: 1 }}
                      transition={{ delay: 0.3 }}
                    >
                      {project.description}
                    </motion.p>

                    <motion.div
                      whileHover={{ scale: 1.02 }}
                      whileTap={{ scale: 0.98 }}
                      transition={{
                        type: "spring",
                        stiffness: 400,
                        damping: 10,
                      }}
                      className="mt-8 inline-block"
                    >
                      <Link
                        href="/projects"
                        className="inline-flex items-center rounded-lg bg-gradient-to-r from-[#136207] to-[#0f4a05] px-6 py-3 font-medium text-white shadow-md hover:shadow-lg"
                      >
                        Explore Loan
                        <svg
                          className="ml-2 h-5 w-5"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M14 5l7 7m0 0l-7 7m7-7H3"
                          />
                        </svg>
                      </Link>
                    </motion.div>
                  </motion.div>

                  {/* Image Section */}
                  <motion.div
                    className="relative md:w-1/2"
                    whileHover={{ scale: 0.98 }}
                    transition={{ duration: 0.3 }}
                  >
                    <div className="overflow-hidden rounded-xl shadow-lg">
                      <Image
                        src={project.image}
                        width={600}
                        height={800}
                        alt={project.title}
                        className="h-72 w-full object-cover transition-transform duration-500 group-hover:scale-110"
                      />
                    </div>

                    {/* Animated decorative elements */}
                    <motion.div
                      className="absolute -bottom-4 -left-4 h-16 w-16 rounded-full bg-[#88cf07]/20"
                      initial={{ scale: 0 }}
                      whileInView={{ scale: 1 }}
                      transition={{ delay: 0.4 }}
                    />
                    <motion.div
                      className="absolute -right-4 -top-4 h-12 w-12 rounded-lg bg-[#136207]/20"
                      initial={{ scale: 0 }}
                      whileInView={{ scale: 1 }}
                      transition={{ delay: 0.6 }}
                    />
                  </motion.div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>

      {/* //yegna other uniqueloan */}
      <div
        className="mt-20 px-4 lg:mx-auto lg:max-w-[1500px]"
        id="special-loans"
      >
        {/* <h2 className="mb-12 text-center font-orbitron text-4xl font-bold text-[#136207] underline decoration-[#136207] decoration-4 sm:text-5xl">
    Special Loan Products
  </h2> */}

        <div className="py-16">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="mb-16 text-center text-4xl font-bold text-[#136207] sm:text-5xl"
          >
            <span className="relative inline-block">
              <span className="bg-gradient-to-r from-[#136207] to-[#88cf07] bg-clip-text text-transparent">
                Yegna Special Loan
              </span>
              <motion.span
                className="absolute bottom-0 left-0 h-1 w-full bg-gradient-to-r from-[#136207] to-[#88cf07]"
                initial={{ scaleX: 0 }}
                animate={{ scaleX: 1 }}
                transition={{ duration: 0.8, delay: 0.3 }}
              />
            </span>
          </motion.h2>

          <div className="mt-16 space-y-28">
            {otheryegna.map((loan, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className={`flex flex-col ${index % 2 === 0 ? "md:flex-row" : "md:flex-row-reverse"} gap-10 md:gap-16`}
              >
                {/* Image Section */}
                <motion.div
                  className="group relative md:w-1/2"
                  whileHover={{ scale: 0.98 }}
                  transition={{ duration: 0.3 }}
                >
                  <div className="relative aspect-video overflow-hidden rounded-xl shadow-lg">
                    <Image
                      src={loan.image}
                      alt={loan.title}
                      fill
                      className="object-cover grayscale transition-all duration-500 group-hover:scale-105 group-hover:grayscale-0"
                    />
                    <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[#136207]/20" />
                  </div>
                  <motion.div
                    className="absolute -bottom-4 -left-4 h-16 w-16 rounded-full bg-[#88cf07]/20"
                    initial={{ scale: 0 }}
                    whileInView={{ scale: 1 }}
                    transition={{ delay: 0.4 }}
                  />
                  <motion.div
                    className="absolute -right-4 -top-4 h-12 w-12 rounded-lg bg-[#136207]/20"
                    initial={{ scale: 0 }}
                    whileInView={{ scale: 1 }}
                    transition={{ delay: 0.6 }}
                  />
                </motion.div>

                {/* Content Section */}
                <motion.div
                  className="md:w-1/2"
                  initial={{ x: index % 2 === 0 ? 50 : -50 }}
                  whileInView={{ x: 0 }}
                  transition={{ duration: 0.6 }}
                >
                  <div className="flex items-start">
                    <motion.div
                      className="mr-4 h-8 w-1 bg-gradient-to-b from-[#136207] to-[#88cf07]"
                      initial={{ scaleY: 0 }}
                      whileInView={{ scaleY: 1 }}
                      transition={{ duration: 0.5 }}
                    />
                    <div>
                      <motion.h3
                        className="text-3xl font-bold text-[#136207]"
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        transition={{ delay: 0.2 }}
                      >
                        {loan.title}
                      </motion.h3>
                      <motion.div
                        className="mt-3 h-1 w-16 bg-gradient-to-r from-[#136207] to-[#88cf07]"
                        initial={{ scaleX: 0 }}
                        whileInView={{ scaleX: 1 }}
                        transition={{ delay: 0.4 }}
                      />
                    </div>
                  </div>

                  <motion.p
                    className="mt-6 text-lg text-gray-700"
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{ delay: 0.3 }}
                  >
                    {loan.description}
                  </motion.p>

                  <motion.div
                    className="mt-8"
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{ delay: 0.5 }}
                  >
                    <div className="flex flex-wrap gap-3">
                      {[
                        `Terms: ${index % 2 === 0 ? "12-36 months" : "6-24 months"}`,
                        `Collateral: ${index % 3 === 0 ? "Required" : "Flexible"}`,
                        `Repayment: ${index % 2 === 0 ? "Monthly" : "Quarterly"}`,
                      ].map((item, i) => (
                        <motion.span
                          key={i}
                          className="rounded-full bg-[#f0f8ec] px-4 py-1.5 text-sm font-medium text-[#136207]"
                          initial={{ scale: 0 }}
                          whileInView={{ scale: 1 }}
                          transition={{ delay: 0.2 + i * 0.1 }}
                          whileHover={{ scale: 1.05 }}
                        >
                          {item}
                        </motion.span>
                      ))}
                    </div>

                    <motion.div
                      whileHover={{ scale: 1.02 }}
                      whileTap={{ scale: 0.98 }}
                      transition={{
                        type: "spring",
                        stiffness: 400,
                        damping: 10,
                      }}
                      className="mt-8 inline-block"
                    >
                      <Link
                        href="#"
                        className="inline-flex items-center rounded-lg bg-gradient-to-r from-[#136207] to-[#0f4a05] px-6 py-3 font-medium text-white shadow-md hover:shadow-lg"
                      >
                        Apply now
                        <svg
                          className="ml-2 h-5 w-5"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M14 5l7 7m0 0l-7 7m7-7H3"
                          />
                        </svg>
                      </Link>
                    </motion.div>
                  </motion.div>
                </motion.div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
